import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { MyRoadmapData } from "./types";

type Response = {
  data?: MyRoadmapData | null;
  error?: ApiError;
};

export const GetMyRoadmap = async (): Promise<Response> => {
  try {
    const response = await axios.get("/cert-roadmap/me");
    const data = response.data.data ?? response.data;

    if (!data?.roadmap) {
      return { data: null };
    }

    return { data };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      // No roadmap yet — treat as empty, not a hard failure.
      if (error.response.status === 404) {
        return { data: null };
      }
      return {
        error: {
          statusCode: error.response.status,
          message: error.response.data.message,
          error: error.response.data.error,
        },
      };
    }
    return {
      error: { statusCode: 500, message: "An unexpected error occurred" },
    };
  }
};
